import style from "../styles/contact-banner.module.scss";
import Button from "./button";

export default function ContactBanner({emergency}: {emergency?: string}) {
  return (
    <div className={emergency ? style.emergencyBanner : style.bannerContainer}>
      <h3>Call us today on</h3>
      <Button>
        <a href="tel:+447572519628" className={style.anchor}>
          07572519628
        </a>
      </Button>
      <h3>or</h3>
      <Button>
        <a
          href="https://wa.me/+447572519628"
          target="_blank"
          rel="noopener noreferrer"
          className={style.anchor}
        >
          Whatsapp us
        </a>
      </Button>
    </div>
  );
}
